/* eslint-disable no-undef */
// Polyfill process and global for browser libraries
if (typeof window !== "undefined") {
  window.process = window.process || {};
  window.process.env = window.process.env || { NODE_ENV: "development" };
  window.process.browser = true;
  window.process.version = window.process.version || "";
  window.process.nextTick = window.process.nextTick || function (fn) { setTimeout(fn, 0); };
  window.global = window.global || window;
}

if (typeof globalThis !== "undefined") {
  globalThis.process = globalThis.process || (typeof window !== "undefined" ? window.process : { env: { NODE_ENV: "development" } });
  globalThis.global = globalThis.global || (typeof window !== "undefined" ? window : globalThis);
}
